import * as React from 'react'

export const SVG_Resume = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43">
        <g fill="none" fillRule="evenodd">
            <circle cx="21.5" cy="21.5" r="21.5" fill="#8E6AF6" />
            <path
                fill="#FFF"
                fillRule="nonzero"
                d="M15.363 15.097a.729.729 0 0 1 .728 0l7.546 6.276a.725.725 0 0 1 0 1.254l-7.546 6.276a.725.725 0 1 1-1.09-.628l-.001-12.55c0-.26.139-.498.363-.628zM25 15.29v13.42c0 .16.131.29.293.29h2.414c.162 0 .293-.13.293-.29V15.29c0-.16-.131-.29-.293-.29h-2.414a.292.292 0 0 0-.293.29z"
            />
        </g>
    </svg>
)
